export default __webpack_public_path__ + "static/Ram-Evrchat-CEO-e3a3cae70fd53a39b71ba286e7612241.jpg";